import { useEffect } from 'react';

/**
 * Setzt Titel, Beschreibung und Canonical je Seite.
 *
 * Bisher trugen alle rund 40 Marketingseiten denselben Titel und dieselbe
 * Beschreibung aus index.html. Fuer Google sind das Dubletten: Es gibt keinen
 * Grund, /funktionen/rechnungen eigenstaendig zu ranken, wenn die Seite sich
 * in Titel und Beschreibung nicht von der Startseite unterscheidet.
 *
 * Bewusst ohne react-helmet: eine Abhaengigkeit weniger, und mehr als das
 * Setzen dreier Elemente ist hier nicht noetig. Der Prerender-Schritt liest
 * den fertigen DOM, die Werte landen also auch im ausgelieferten HTML.
 */
export interface SeoAngaben {
  /** Ohne "| Saldify" — das haengt die Funktion an. */
  titel: string;
  beschreibung: string;
  /** Pfad ohne Domain, z.B. "/funktionen/rechnungen". */
  pfad?: string;
}

const BASIS = 'https://saldify.de';

function setzeMeta(selektor: string, attribut: string, wert: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(selektor);
  if (!el) {
    el = document.createElement('meta');
    const [name, value] = selektor.replace(/^meta\[|\]$/g, '').split('=');
    if (name && value) el.setAttribute(name, value.replace(/["']/g, ''));
    document.head.appendChild(el);
  }
  el.setAttribute(attribut, wert);
}

export function useSeo({ titel, beschreibung, pfad }: SeoAngaben): void {
  useEffect(() => {
    const vollerTitel = titel.includes('Saldify') ? titel : `${titel} | Saldify`;
    document.title = vollerTitel;

    setzeMeta('meta[name="description"]', 'content', beschreibung);
    setzeMeta('meta[property="og:title"]', 'content', vollerTitel);
    setzeMeta('meta[property="og:description"]', 'content', beschreibung);
    setzeMeta('meta[name="twitter:title"]', 'content', vollerTitel);
    setzeMeta('meta[name="twitter:description"]', 'content', beschreibung);

    if (pfad) {
      const url = `${BASIS}${pfad}`;
      let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = url;
      setzeMeta('meta[property="og:url"]', 'content', url);
    }
  }, [titel, beschreibung, pfad]);
}
